export interface PlayerActivityServiceWsDTO {
  action: PlayerActivityServiceCollectionAction;
  collection: string;
  data: any;
}

export enum PlayerActivityServiceCollection {
  ALERTS = 'active-alerts',
}

export enum PlayerActivityServiceCollectionAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  REMOVED = 'REMOVED',
}
